import { FormikValues } from 'formik'

export interface UpdateMaturityComplianceRuleValues extends FormikValues {
  displayTextKey: string
  id: number
  maturityDaysFrom: number
  maturityDaysTo: number
  maxLimit: number
  minLimit: number
}

export const updateMaturityComplianceRuleValues: UpdateMaturityComplianceRuleValues = {
  displayTextKey: null,
  id: 0,
  maturityDaysFrom: 0,
  maturityDaysTo: 0,
  maxLimit: 0,
  minLimit: 0,
}
